export default {
  trainings: [],
  onboarding: [],
  departure: [],
  orientation: [],
  packages: [],

  sequence: undefined,
  completedSequence: undefined,
  completedAssociateSequence: {
    training: undefined,
    onboarding: undefined,
    departure: undefined,
    orientation: undefined
  },

  purchased: {
    sequence_ids: [],
    package_ids: []
  }
}
